import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { SubscribeComponent } from '../subscribe/subscribe.component';

@Component({
  selector: 'app-renew-subscription',
  templateUrl: './renew-subscription.component.html',
  styleUrls: ['./renew-subscription.component.scss']
})
export class RenewSubscriptionComponent implements OnInit {
  @Input() data;
  constructor(
    private activeModal: NgbActiveModal,
    private router: Router,
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
  }
  closeDialog() {
    this.activeModal.close();
  }

  goToDetailsPage() {
    if (this.data.collection_type) {
      this.activeModal.close();
      this.router.navigate(["/material-detail-page", this.data.id, "private"]);
    } else {
      this.router.navigate(['/collection', this.data.slug])
    }
  }

  purchaseSubscription() {
    const modalRef = this.modalService.open(SubscribeComponent, { centered: true, size: "lg", backdrop: 'static', keyboard: false });
    modalRef.componentInstance.currentuser = this.data.user;
    modalRef.result.then((response) => {
      if (response) {
        this.activeModal.close();
      }
    }, (error) => {

    })
  }

}
